import React, { useState } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { useAppSelector } from '../../app/hooks';

// The flag it reads is a first-login signal, not a completeness check: it is true on the first page
// load after an invitee's first login and false once the acceptance flip lands. The save thunks
// merge rather than replace, so a save cannot clear it mid-form; a token renewal re-reads it and
// is how the banner leaves once the flip has landed.
// Dismissal is component state on purpose — the store is persisted, and a persisted dismissal would
// outlive the one page load this banner is meant for.
const ProfileWelcomeBanner: React.FC = () => {
    const { data } = useAppSelector(store => store.currentUser);
    const [dismissed, setDismissed] = useState(false);

    if (dismissed || !data?.profileCompletionRequired) {
        return null;
    }

    return (
        <Alert severity="info" onClose={() => setDismissed(true)} sx={{ mb: 4 }}>
            <AlertTitle>Welcome to Logistics Plus</AlertTitle>
            Your account is ready — add your address and contact details on the tabs to the left so
            your applications have them.
        </Alert>
    );
};

export default ProfileWelcomeBanner;
